// ============================================================
// Xap Xam Card Game — Configuration Constants
// Owner-adjustable settings for game platform
// ============================================================

export const MAX_PLAYERS_PER_TABLE = 12;
export const MAX_DECKS = 5;

// Test override: append ?testTimer=N&testOvertime=N to URL to shorten timers for e2e tests
const _urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const _testTimer = _urlParams && parseInt(_urlParams.get('testTimer'));
const _testOvertime = _urlParams && parseInt(_urlParams.get('testOvertime'));

export const ARRANGEMENT_TIMER_SECONDS = _testTimer > 0 ? _testTimer : 90;
export const OVERTIME_SECONDS = _testOvertime > 0 ? _testOvertime : 15;
export const RULE_ACKNOWLEDGMENT_TIMEOUT_SECONDS = 60;
export const DEAL_ANIMATION_SECONDS = 3;
export const ROOM_STABILIZATION_HOURS = 2;

// Card constants
export const RANKS = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
export const SUITS = ['S', 'H', 'D', 'C']; // Spades, Hearts, Diamonds, Clubs
export const RANK_VALUES = {
  '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8,
  '9': 9, '10': 10, 'J': 11, 'Q': 12, 'K': 13, 'A': 14,
};

// Hand size requirements
export const BOTTOM_SIZE = 5;
export const MIDDLE_SIZE = 5;
export const TOP_SIZE = 3;
export const HAND_SIZE = BOTTOM_SIZE + MIDDLE_SIZE + TOP_SIZE; // 13

// Game modes
export const GAME_MODES = {
  BASIC: 'basic',
  NEM: 'nem',
  CHI: 'chi',
  NEM_CHI: 'nemchi',
  SCORE_TRACKER: 'score',
};

// Nem discard directions (only deck and skip supported)
export const NEM_DIRECTIONS = {
  DECK: 'deck',
  SKIP: 'skip',
};

// 5-card hand type ranks (higher = stronger)
export const HAND_TYPES = {
  HIGH_CARD: 0,
  ONE_PAIR: 1,
  TWO_PAIR: 2,
  THREE_OF_A_KIND: 3,
  STRAIGHT: 4,
  FLUSH: 5,
  FULL_HOUSE: 6,
  FOUR_OF_A_KIND: 7,
  STRAIGHT_FLUSH: 8,
  ROYAL_FLUSH: 9,
  FIVE_OF_A_KIND: 10,
};

// 3-card hand type ranks (top row — no straights/flushes)
export const TOP_HAND_TYPES = {
  HIGH_CARD: 0,
  ONE_PAIR: 1,
  THREE_OF_A_KIND: 2,
};

// Chi mode bonus values
export const CHI_BONUSES = {
  THREE_OF_A_KIND_TOP: 3,
  FULL_HOUSE_MIDDLE: 2,
  FOUR_OF_A_KIND_BOTTOM: 4,
  FOUR_OF_A_KIND_MIDDLE: 8,
  STRAIGHT_FLUSH_BOTTOM: 5,
  STRAIGHT_FLUSH_MIDDLE: 10,
  FIVE_OF_A_KIND_BOTTOM: 5,
  FIVE_OF_A_KIND_MIDDLE: 10,
};

// Deck scaling thresholds (Nem modes need spare cards for discard/draw)
// 1 deck (52 cards) for 1-3 players, 2 decks for 4-7, 3 decks for 8+
export const DECK_SCALING = {
  SECOND_DECK_AT: 4,  // Add 2nd deck at 4th player
  THIRD_DECK_AT: 8,   // Add 3rd deck at 8th player
};

// Kick durations (in milliseconds)
export const KICK_DURATIONS = {
  IMMEDIATE: 0,
  FIVE_MIN: 5 * 60 * 1000,
  FIFTEEN_MIN: 15 * 60 * 1000,
  THIRTY_MIN: 30 * 60 * 1000,
  ONE_HOUR: 60 * 60 * 1000,
  FOUR_HOURS: 4 * 60 * 60 * 1000,
  ONE_DAY: 24 * 60 * 60 * 1000,
  PERMANENT: -1,
};
